import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  IconButton,
  Card,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import _ from "lodash";
import { useLoading } from "../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { downloadExcelFile } from "../../function/downloadExcel";
import {
  exportPaymentBalances,
  getCurrentPaymentBalance,
  getPaymentBalanceByPastDate,
  GetTodayPaymentBalance,
  uploadPaymentBalance,
} from "./PaymentBalanceData";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import Swal from "sweetalert2";
import { gql, useMutation } from "@apollo/client";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import URL from "../../../pages/Utils/url";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import PDFURL from "../../../pages/Utils/pdfurl";
import { generateSalesorderPdf } from "../salesOrder/salesOrderData/salesOrderData";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlaceIcon from "@mui/icons-material/Place";
import NewLocationPicker from "../NewCustomer/component/NewCustomerForm/NewLocationPicker";
import { PictureAsPdf } from "@mui/icons-material";
import TanstackTableComponents from "../../../components/tabel";
function PaymentBalanceMaster() {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [UpdateFile] = useMutation(uploadPaymentBalance);
  const { userId } = useAuthData();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [uploadfile, setUploadfile] = useState("");
  const [value, setValue] = useState(0);
  const [dates, setDates] = useState({
    fromDate: "",
    toDate: "",
  });
  const [error, setError] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [checkindata, setcheckindata] = useState(null);
  const [cheeckinoutopen, setcheckinoutopen] = useState(false);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    if (value === 0) {
      fetchCurrentBalancedata();
    } else {
      fetchPastPaymentBalance();
    }
  }, [value, searchValue, pagination, dates]);

  const PaymentBalanceListTable = {
    columns: [
      {
        header: "Customer Code",
        accessorKey: "customerCode",
        cell: (props) => <p>{props.getValue()}</p>,
            meta: {
          sticky: true,
          left: 0,
        },
      },
      {
        header: "Customer Name",
        accessorKey: "customerName",
        cell: (props) => <p>{props.getValue()}</p>,
            meta: {
          sticky: true,
          left: 100,
        },
      },
      {
        header: "Rep Name",
        accessorKey: "repName",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Payment Receivable",
        accessorKey: "paymentReceivable",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Amount Paid",
        accessorKey: "amountPaid",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Outstanding Amount",
        accessorKey: "outstandingAmount",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: (props) => props.getValue(),
      },
      {
        header: "Created By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => props.getValue(),
      },
    ],

    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v?.id || i + 1,
      customerCode: v?.customerCode,
      customerName: v?.customerName,
      repName: v?.repName,
      paymentReceivable: v?.paymentReceivable,
      amountPaid: v?.amountPaid,
      outstandingAmount: v?.outstandingAmount,
      createdOn: v?.createdAt?.slice(0, 10),
      status: (
        <p
          style={{
            color:
              v?.status?.toLowerCase() == "completed"
                ? "#2a9941"
                : v?.status?.toLowerCase() == "yet to visit"
                ? "orange"
                : "red",
            marginTop: "10px",
            fontWeight: "600",
          }}
        >
          {_.startCase(_.toLower(v?.status?.replace(/_/g, " ")))}
        </p>
      ),

      createdBy: v?.createdBy,
      createdOn: v?.createdAt?.slice(0, 10),

      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "5px",
            alignItems: "center",
          }}
        >
          <VisibilityIcon
            fontSize="small"
            className="actionIcon"
            onClick={() =>
              navigate(`/paymentBalance/ViewPaymentBalance`, {
                state: { type: "view", data: v, rowId: v?.id },
              })
            }
          />

          {value == 0 &&
            v?.status?.toLowerCase() !== "completed" &&
            Number(v?.outstandingAmount) !== 0 && (
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate(`/paymentBalance/payment-Collection`, {
                    state: { id: v?.customerCode, repCode: v?.repCode },
                  })
                }
              />
            )}

          <PictureAsPdf
            fontSize="small"
            className="actionIcon"
            onClick={() => handleDownloadPdf(v?.invoices)}
          />

          <LocationOnIcon
            fontSize="small"
            className="actionIcon"
            onClick={() => handleLocation(v)}
          />
        </div>
      ),
    })),
  };

  //fetch by current date
  const fetchCurrentBalancedata = () => {
    setIsLoading(true);
    request(BASEURL, GetTodayPaymentBalance, {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      search: searchValue,
      paginate: true,
    })
      .then((res) => {
        const totalPages = res?.getTodayPaymentBalance.totalPages;
        const totalCount = res?.getTodayPaymentBalance.totalCount;
        const newdata = res?.getTodayPaymentBalance.data;
        setDataCount({
          pageCount: totalPages,
          itemCount: totalCount,
        });
        setData(newdata);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //fetch past day datas
  const fetchPastPaymentBalance = () => {
    setIsLoading(true);
    request(BASEURL, getPaymentBalanceByPastDate, {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      search: searchValue,
      startDate: dates.fromDate || null,
      endDate: dates.toDate || null,
    })
      .then((res) => {
        const newdata = res?.getPaymentBalanceByPastDate.data;
        const totalPages = res?.getPaymentBalanceByPastDate.totalPages;
        const totalCount = res?.getPaymentBalanceByPastDate.totalCount;
        setData(newdata);
        setDataCount({
          pageCount: totalPages,
          itemCount: totalCount,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //download execl
  const handleDownload = (startdate, enddate) => {
    setCirleLoading(true);
    request(BASEURL, exportPaymentBalances, { startdate, enddate }).then(
      async (res) => {
        const status = res?.exportPaymentBalances?.success;

        const pdfurl = `${URL}${res?.exportPaymentBalances?.fileUrl?.slice(1)}`;
        if (status) {
          const status = await downloadExcelFile(
            pdfurl,
            "Payment_balance.xlsx"
          );
          setCirleLoading(false);
        }
      }
    );
  };

  //excel upload

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          input: {
            file: file,
            userId: userId,
          },
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.uploadPaymentBalanceFile?.success;
      const message = response?.data?.uploadPaymentBalanceFile?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchCurrentBalancedata();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  //tab onchange
  const handleChange = (event, newValue) => {
    setData([]);
    setValue(newValue);
  };

  //date onchange
  const handleDateChange = (event) => {
    const { name, value } = event.target;

    setDates((prev) => {
      const updatedDates = { ...prev, [name]: value };

      // Validation: Check if To Date is less than From Date
      if (name === "toDate" && updatedDates.toDate < updatedDates.fromDate) {
        setError("To Date cannot be earlier than From Date.");
      } else {
        setError(""); // Clear error if valid
      }

      return updatedDates;
    });
  };

  const handleUploadClick = () => {
    setUploadStatus(false); // reset first
    setTimeout(() => setUploadStatus(true), 0); // open again after reset
  };

  const handleDownloadPdf = async (id) => {
    // Convert to array of numbers
    const idArray = id?.map((item) => Number(item.id)); // <-- CONVERT TO INT

    const query = gql`
      mutation GenerateInvoicePdf($ids: [Int]!) {
        generateInvoicePdf(ids: $ids) {
          success
          message
          pdfUrl
        }
      }
    `;

    setCirleLoading(true);

    try {
      const res = await request(BASEURL, query, {
        ids: idArray,
      });

      const success = res?.generateInvoicePdf?.success;
      const message = res?.generateInvoicePdf?.message;
      const pdfUrl = `${PDFURL}${res?.generateInvoicePdf?.pdfUrl}`;

      if (success && pdfUrl) {
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", "Cash Receipt.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error downloading PDF:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleLocation = (value) => {
    const status = value?.checkins == 0;
    if (status) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "No Checkin",
        text: "",
        showConfirmButton: true,
      });
    } else {
      setcheckinoutopen(true);
      setcheckindata(value);
    }
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  return (
    <DashboardLayout>
      <Dialog open={cheeckinoutopen} onClose={() => setcheckinoutopen(false)}>
        <DialogTitle
          sx={{
            backgroundColor: "#2a9941",
            color: "white",
            fontWeight: "bold",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          Check-In & Check-Out Details
        </DialogTitle>

        <DialogContent
          sx={{
            backgroundColor: "#f9f9f9",
            padding: "20px",
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0 10px",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#e3f2fd", borderRadius: 10 }}>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Check-in{" "}
                  <IconButton
                    onClick={() => {
                      setSelectedLocation({
                        lat: checkindata?.checkins[0]?.checkinLocationLat,
                        lng: checkindata?.checkins[0]?.checkinLocationLng,
                      });
                      setMapOpen(true);
                    }}
                    size="small"
                  >
                    <PlaceIcon fontSize="small" color="primary" />
                  </IconButton>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Check-out{" "}
                  <IconButton
                    onClick={() => {
                      setSelectedLocation({
                        lat: checkindata?.checkouts[0]?.checkoutLocationLat,
                        lng: checkindata?.checkouts[0]?.checkoutLocationLng,
                      });
                      setMapOpen(true);
                    }}
                    size="small"
                  >
                    <PlaceIcon fontSize="small" color="error" />
                  </IconButton>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Duration
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.2s",
                  borderRadius: 10,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.01)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkins[0]?.checkInTime || "—"}
                </td>
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkouts[0]?.checkOutTime || "—"}
                </td>
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkouts[0]?.duration || "—"}
                </td>
              </tr>
            </tbody>
          </table>
        </DialogContent>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Payment Balance List
                </MaterialTypography>
              </Stack>
              {dates.fromDate && dates.toDate && value === 1 && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(dates?.fromDate, dates?.toDate);
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
              {/* <label
                className="container-btn-file"
                style={{
                  height: "38px",
                  marginLeft: "0",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <input
                  type="file"
                  accept=".xls, .xlsx"
                  onChange={(e) => handleExcelUpload(e)}
                  style={{ display: "none" }}
                />
                <svg
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 50"
                >
                  <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                </svg>
                Upload File
              </label> */}
              <label
                className="container-btn-file"
                style={{
                  height: "38px",
                  marginLeft: "0",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onClick={() => handleUploadClick()} // show the modal
              >
                <svg
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 50"
                >
                  <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                </svg>
                Upload File
              </label>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() =>
                  navigate("/paymentBalance/paymentBalanceForm", {
                    state: { type: "add" },
                  })
                }
              >
                Payment Balance
              </MaterialButton>
            </Stack>
          }
        />
        {/* tabs */}
        <Box sx={{ my: "5px" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#2a9941",
                    color: "white",
                  },
                }}
                centered
              >
                <Tab label="Today Payment Balance list" />
                <Tab label="Past Payment Balance list" />
              </Tabs>
            </Box>

            {/* filter fields */}
            {value === 1 && (
              <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        From Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      type="date"
                      size="small"
                      name="fromDate"
                      value={dates.fromDate}
                      onChange={handleDateChange}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        To Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      type="date"
                      size="small"
                      name="toDate"
                      value={dates.toDate}
                      onChange={handleDateChange}
                    />
                    {error && (
                      <MaterialTypography
                        color="error"
                        variant="caption"
                        display="block"
                        mt={1}
                      >
                        {error}
                      </MaterialTypography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            )}
          </Stack>
        </Box>
        {uploadStatus && (
          <FileUploadModal
            key={Date.now()} // force remount
            status={uploadStatus}
            onClose={() => setUploadStatus(false)}
            onSubmit={(file) => handleExcelUpload(file)}
          />
        )}
        <NewLocationPicker
          open={mapOpen}
          onClose={() => setMapOpen(false)}
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
        />

        <TanstackTableComponents
          rows={PaymentBalanceListTable?.rows}
          columns={PaymentBalanceListTable?.columns}
          pagination={pagination}
          setPagination={setPagination}
          pageCount={dataCount.pageCount}
          recordCount={dataCount.itemCount}
          isLoading={isLoading}
          isSearch={true}
          onChange={handleSearch}
        />
      </Card>
    </DashboardLayout>
  );
}

export default PaymentBalanceMaster;
